module.exports = __webpack_public_path__ + "media/images/flags/1x1/gmb-d6118dc214e13a17de1b959c211f6b17.svg";